import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import _ from 'lodash';
import { ICounter, ICounterFilter } from "./counters.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class CountersService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService,
  ) { }

  getCounter(counter: ICounter | string): Observable<any> {
    let id = (typeof counter == 'string') ? counter : counter._id;
    return this._http.get(`${apiURL(EnvConfig.API_COUNTERS)}/${id}`);
  }

  getCounters(filter?: ICounterFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_COUNTERS)}${queryParams}`);
  }

  getCountersSeries(filter?: ICounterFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_COUNTERS)}${queryParams}`).pipe(
      map(response => response.filter((counter: any) => counter.reference_value && counter.reference_value.serie)));
  }

  getCountersValues(filter?: ICounterFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_COUNTERS)}${queryParams}`).pipe(
      map(response => response.map((el: any) => el.reference_value.serie).filter((el: any) => el != undefined))
    );
  }

  createCounter(counter: ICounter): Observable<any> {
    return this._http._post(`${apiURL(EnvConfig.API_COUNTERS)}`, counter);
  }
}